import styled from "@emotion/styled";
import { MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH } from "constants/vp-sizes";
export const StyledRichTextBlogComponent = styled.div`
  max-width: ${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px;
  margin: auto;
  display: flex;
  justify-content: center;
  .rich-text-body {
    font-size: 0.875rem;
  }
  &.left {
    justify-content: flex-start;
  }

  &.right {
    justify-content: flex-end;
  }
`;
